// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api_url: 'https://api.appsalescyan.com/api', // "http://localhost:10000/api", // "https://hpcprodwebapi.azurewebsites.net", //'http://10.0.0.240:2226/api',
  CONTACT_QUALITY: 100,
  CONTACT_WIDTH: 220,
  EVENT_QUALITY: 100,
  EVENT_WIDTH: 220,
  FAQ_QUALITY: 100,
  FAQ_WIDTH: 220,
  FORM_QUALITY: 100,
  FORM_WIDTH: 220,
  LINK_QUALITY: 100,
  LINK_WIDTH: 220,
  NEWS_QUALITY: 100,
  NEWS_WIDTH: 220,
  OFFER_QUALITY: 100,
  OFFER_WIDTH: 220,
  USER_QUALITY: 100,
  USER_WIDTH: 220,
  NOTIFICATION_QUALITY: 100,
  NOTIFICATION_WIDTH: 220,
  OneGBINByte: 1000000000,
  POSTVISIBLETO: '1,58,5,65',
  SHOWPOSTTOTALVIEWS: '1,58,5',
  SHOWOFFERREDEEMEDEXPORT: '1,58,5',
  SHOWFEATUREDIMAGEVIDEOBANNER: '1,58,5',
  UNITSELECTIONINFORMATION: '1,58',
  FAQQUESTIONCATEGORY: '1,58,65',
  CATEGORYMULTISELECT: '1,58,65',
  googleAPIKey: "AIzaSyCShiqFsPu5jbMOaeo4dxLV72YBiy8uju8",
  agmAPIKey: "AIzaSyCE0nvTeHBsiQIrbpMVTe489_O5mwyqofk",
  KIOSKDISPLAY:"1,58,65"//jernhusen depa,test,studio app have feature kiosk screen
};



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/environments/environment.ts